<template>
  <header class="site-header">
    <div class="nav-wrap">
      <router-link class="brand" :to="{ name: 'en-gb' }" :aria-label="`${brand} home`">
        <img class="brand-mark" src="/favicon.ico?v=20260721" :alt="brand" />
        <span class="brand-text">{{ brand }}</span>
      </router-link>

      <button class="menu-toggle" type="button" @click="isMenuOpen = !isMenuOpen" aria-label="Toggle menu">
        <span />
        <span />
        <span />
      </button>

      <nav class="nav-links" :class="{ open: isMenuOpen }" aria-label="Primary navigation">
        <router-link :to="{ name: 'en-gb' }" exact>Home</router-link>
        <router-link :to="{ name: 'en-download' }">Download</router-link>
        <router-link :to="{ name: 'en-update' }">Update</router-link>
        <router-link :to="{ name: 'en-old-version' }">Old Version</router-link>
        <router-link :to="{ name: 'en-guides' }">Guides</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { SITE_BRAND_UPPER } from '@/config/site'

export default {
  name: 'HeadNav',
  data() {
    return {
      isMenuOpen: false,
      brand: SITE_BRAND_UPPER,
    }
  },
}
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e5ece8;
  box-shadow: 0 2px 10px rgba(16, 24, 20, 0.05);
}

.nav-wrap {
  width: min(1180px, calc(100% - 48px));
  min-height: 70px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #111111;
  text-decoration: none;
  font-family: Inter, Arial, sans-serif;
  font-weight: 800;
  text-transform: uppercase;
}

.brand-mark {
  width: 40px;
  height: 40px;
  display: block;
  border-radius: 10px;
  object-fit: contain;
}

.brand-text {
  font-size: 24px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.nav-links {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(40px, 4vw, 72px);

  a {
    color: #4b5563;
    text-decoration: none;
    font-family: Inter, Arial, sans-serif;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 8px 4px;
  }

  a:hover,
  .router-link-active {
    color: #25d366;
  }
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid #d8e5de;
  border-radius: 6px;
  background: #ffffff;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;

  span {
    display: block;
    width: 20px;
    height: 2px;
    background: #173127;
  }
}

@media (max-width: 820px) {
  .nav-wrap {
    width: min(1180px, calc(100% - 32px));
    min-height: 64px;
  }

  .menu-toggle {
    display: inline-flex;
  }

  .nav-links {
    width: auto;
    margin-left: 0;
    display: none;
    position: absolute;
    top: 64px;
    left: 16px;
    right: 16px;
    padding: 16px;
    background: #ffffff;
    border: 1px solid #e5ece8;
    border-radius: 8px;
    box-shadow: 0 18px 34px rgba(16, 24, 20, 0.12);
    align-items: stretch;
    flex-direction: column;
    gap: 10px;

    &.open {
      display: flex;
    }

    a {
      padding: 12px 10px;
    }
  }

}
</style>
